import { GridFilterOperator } from "@mui/x-data-grid-pro";

import { operator } from "types";

export const getGridNullCheckOperators = (
  nonNullLabel: string,
  nullLabel: string
): GridFilterOperator[] => [
  // Equality
  {
    label: nonNullLabel,
    value: operator.isNonNull,
    getApplyFilterFn: () => {
      return (params) => {
        return !!params;
      };
    }
  },
  {
    label: nullLabel,
    value: operator.isNull,
    getApplyFilterFn: () => {
      return (params) => {
        return !params;
      };
    }
  }
];
